
import { fechFromBPartsApi } from '../utils';
import { IncomingMessage } from 'http';


export const fetchLanguages = (
  {
    locale,
  }: {
    locale: string;
  },
  req?: IncomingMessage
): Promise<Languages> =>
  fechFromBPartsApi(`/${locale}/shop/languages`, {
    credentials: 'include',
    headers: req ? new Headers(req.headers as HeadersInit) : undefined,
  }).then((value) => value.json());
